import { DEVICE_STATUSES } from '~/utils/constants';
import { STATUS_COLORS } from '~/theme/types';
import I18n from '~/utils/i18n';
import type { ITotalDevicesWidget } from '.';
import { omit } from 'lodash';

export default (self: ITotalDevicesWidget) => ({
  get pieChartData() {
    return [
      {
        name: I18n.t('thiamis.states.offline'),
        color: STATUS_COLORS[DEVICE_STATUSES.OFFLINE],
        y: self.data?.devices.offline
      },
      {
        name: I18n.t('thiamis.states.online'),
        color: STATUS_COLORS[DEVICE_STATUSES.ONLINE],
        y: self.data?.devices.online
      },
      {
        name: I18n.t('thiamis.states.inventory'),
        color: STATUS_COLORS[DEVICE_STATUSES.INVENTORY],
        y: self.data?.devices.inventory
      },
      {
        name: I18n.t('thiamis.states.deactivated'),
        color: STATUS_COLORS[DEVICE_STATUSES.DEACTIVATED],
        y: self.data?.devices.deactivated
      }
    ].filter(({ y }) => y);
  },
  get total() {
    return self.pieChartData.reduce((sum, { y }) => sum + (y ?? 0), 0);
  },
  get columnChartSeries() {
    const data = Object.entries(omit(self.data, ['devices']));
    return [
      {
        name: I18n.t('thiamis.states.online'),
        color: STATUS_COLORS[DEVICE_STATUSES.ONLINE],
        data: data?.map(([, { online }]) => online)
      },
      {
        name: I18n.t('thiamis.states.offline'),
        color: STATUS_COLORS[DEVICE_STATUSES.OFFLINE],
        data: data?.map(([, { offline }]) => offline)
      },
      {
        name: I18n.t('thiamis.states.deactivated'),
        color: STATUS_COLORS[DEVICE_STATUSES.DEACTIVATED],
        data: data?.map(([, { deactivated }]) => deactivated)
      },
      {
        name: I18n.t('thiamis.states.inventory'),
        color: STATUS_COLORS[DEVICE_STATUSES.INVENTORY],
        data: data?.map(([, { inventory }]) => inventory)
      }
    ].filter(({ data: chartData }) => chartData.some((number) => number));
  },
  get columnChartCategories() {
    return Object.entries(omit(self.data, ['devices'])).map(([deviceType]) =>
      I18n.t(`filters.filter-tags.device-type.${deviceType.toLowerCase()}`, {
        defaultValue: deviceType
      })
    );
  }
});
